import { IField, IOptionsWithTypes, spLogTags } from '@eventr/common'
import {
    ColoursObj,
    MainButton,
    Typography,
    useValidatorContext,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useSignalEffect } from '@preact/signals-react'
import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { IEditComponent } from '../../../data/Data'
import i18n from '../../../i18n/i18next'
import { bs, useBoundStore } from '../../../state/bound.store'
import { useEditSectionContext } from '../editSectionProvider'

interface IAttendeesOptions {
    editSubPageId?: number
    editSubPageSingleId?: number
}
interface IAttendeesProps {
    options: IEditComponent & IAttendeesOptions
    _id?: string
}

interface IUsers {
    users: IOptionsWithTypes[]
    _id: string
    [key: string]: any
}

//get get users from department and get users from group function

export const Attendees = ({ options, _id }: IAttendeesProps) => {
    const { getValue, isNewItem, updateValues } = useEditSectionContext()
    const { fields } = useBoundStore(
        useShallow((s) => {
            return {
                fields: s.fields,
            }
        })
    )

    const { isAllValid, setShowErrors } = useValidatorContext()

    const [membersListSelectList, setMembersListSelectList] = useState<any[]>(
        []
    )

    const field = fields?.find((field: IField) => {
        return field.id.toString() === options.fieldId?.toString()
    })

    const userField = fields?.find((field: IField) => {
        if (options.userListFieldId) {
            return field.id.toString() === options.userListFieldId.toString()
        } else {
            return false
        }
    })

    function getUniqueUserList(userList: IUsers[], usersKey: string = 'users') {
        const itinMembersIds = useBoundStore
            .getState()
            .selectedItineraryUsers()
            .map((user) => {
                return user.id
            })

        let users: IOptionsWithTypes[] = []
        userList?.forEach((user) => {
            try {
                user[usersKey].forEach((user: IOptionsWithTypes) => {
                    if (
                        user.type === 'User' &&
                        itinMembersIds.includes(Number(user.option))
                    ) {
                        users.push(user)
                    }
                })
            } catch { }
        })

        let uniqueUsers: IOptionsWithTypes[] = []
        users.forEach((user) => {
            if (!uniqueUsers?.some((u) => u.option === user.option)) {
                uniqueUsers.push(user)
            }
        })
        return uniqueUsers
    }

    useSignalEffect(() => {
        const initFieldValue = field ? getValue(field, _id) : undefined
        setMembersListSelectList(initFieldValue)
    })

    useEffect(() => {
        try {
            updateValues({
                value: membersListSelectList,
                field: field,
                _id: _id,
            })
        } catch { }
    }, [membersListSelectList])

    const membersListOfLists = field ? getValue(field, _id) : undefined
    let uniqueUsers = getUniqueUserList(
        membersListOfLists,
        userField?.type_properties?.json_key
    )

    const currentUsers = (users: IOptionsWithTypes[]) => {
        const x = users
            .map((u) => {
                if (typeof u.option === 'number') {
                    const user = useBoundStore
                        .getState()
                        .getUserFromID(u.option)
                    if (!user) return undefined
                    if (user.firstName && user.lastName) {
                        return bs().getNameFormatted(user)
                    } else {
                        return user.email
                    }
                }
            })
            .filter((x) => x !== undefined)

        return x.join(', ')
    }

    let currentUsersList = currentUsers(uniqueUsers)

    const changePage = () => {
        const path = window.location.pathname

        if (!isAllValid) {
            spLogTags('Fields not valid for saving', ['SAVE'])
            setShowErrors(true)
            return
        }

        if (_id && isNewItem(_id)) {
            const subPage = options.editSubPageSingleId ?? 0
            window.pushPath(
                `${path.split('/1/')[0]}/${subPage}/${membersListSelectList[0]._id
                }`
            )
            return
        } else {
            const subPage = options.editSubPageId ?? 0
            window.pushPath(`${path.split('/1/')[0]}/${subPage}/${_id}`)
            return
        }
    }

    return (
        <Stack
            spacing={'16px'}
            overflow="hidden"
            textOverflow="ellipsis"
            width="100%"
        >
            <MainButton
                id={`${options.headerText}-button`}
                onClick={changePage}
            >
                {i18n.t(
                    `edit-itinerary.headers.${options.headerText
                        ? options.headerText.replace(/\. | /g, '-').toLowerCase()
                        : ''}`
                ) ?? 'Team'}
            </MainButton>
            <Typography
                id={`${options.headerText}-users-list`}
                textOverflow="ellipsis"
                overflow="hidden"
                variant="bodyRegular"
                width="90vw"
                color={ColoursObj.core.primary}
            >
                {currentUsersList}
            </Typography>
        </Stack>
    )
}
